import { createGlobalStyle } from 'styled-components';

const GlobalCarouselStyle = createGlobalStyle`
  .carousel .control-arrow {
    width: 100px;
    height: 100%;
    opacity: 0.25;
    background: transparent;
    transition: all 0.3s ease;
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 2;
  }

  .carousel .control-arrow:hover {
    background: var(--shadow-a45);
    opacity: 0.5;
  }

  .carousel .control-prev.control-arrow {
    left: 0;
  }

  .carousel .control-next.control-arrow {
    right: 0;
  }

  .carousel .control-arrow::before {
    font-size: 1.6rem;
    color: var(--grey-700);
  }
`;

export default GlobalCarouselStyle;